import React from 'react'

import { ScrollContainer } from '@factorialco/deprecated-design-system'
import {
  PerformanceQuestionSingleLabel,
  PerformanceQuestionnaireByReviewerStrategyFragment,
  PerformanceReviewerStrategiesStrategyEnum,
  PerformanceTargetWithPublishedEvaluationsFragment,
} from 'generated/resources/graphql'

import AnswersTable from 'modules/performance_process/components/insights/Answers/common/AnswersTable'
import {
  Answer,
  extractQuestions,
  present,
  publishedAnswersWithTargetByReviewType,
} from 'modules/performance_process/components/insights/common/presenters'

import { EmptyState } from './EmptyState'

interface TargetAnswersProps {
  reviewType: PerformanceReviewerStrategiesStrategyEnum
  target: PerformanceTargetWithPublishedEvaluationsFragment
  reviewQuestionnaireByReviewerStrategy: PerformanceQuestionnaireByReviewerStrategyFragment
  onSelectQuestion: (question: PerformanceQuestionSingleLabel) => void
  onSelectAnswer: (answer: Answer) => void
}

export const TargetAnswersTable: React.FC<TargetAnswersProps> = ({
  reviewType,
  target,
  reviewQuestionnaireByReviewerStrategy,
  onSelectQuestion,
  onSelectAnswer,
}) => {
  // Get an object for the target with its answers for the selected reviewType
  const publishedAnswersWithTarget = publishedAnswersWithTargetByReviewType([target], reviewType)

  const { targets, answers, targetsWithReviewers } = present(
    publishedAnswersWithTarget, // Array of target objects with answers, already filtered by reviewType
    reviewType
  )

  // Get questions for the given reviewType
  const qualitativeQuestionsForStrategy = extractQuestions(
    reviewQuestionnaireByReviewerStrategy,
    reviewType
  )

  return (
    <ScrollContainer>
      {answers.length > 0 ? (
        <AnswersTable
          targets={targets}
          questions={qualitativeQuestionsForStrategy || []}
          answers={answers}
          targetsWithReviewers={targetsWithReviewers}
          renderCell={(question, answer) => (
            <AnswersTable.AnswerCell
              answer={answer}
              onClick={() => {
                if (!answer) return
                onSelectQuestion(question)
                onSelectAnswer(answer)
              }}
            />
          )}
        />
      ) : (
        <EmptyState />
      )}
    </ScrollContainer>
  )
}
